import { IDosage } from '@alberta/konexi-shared';

import { IShoppingCartMaxAmountArticleLine } from '../shopping-cart/shopping-cart-max-amount-article-view-model';
import { caluclateDurationToDays } from './duration2daysCalcuator';

export function normalizeDosageQuantityTo30Days(dosage: IDosage, itemsInPackagingUnit: number): number {
  const totalItems = dosage.quantity * itemsInPackagingUnit;
  const daysInDosage = caluclateDurationToDays(dosage.duration);
  const daysNormalized = 30;
  const piecesInOneDay = totalItems / daysInDosage;
  return piecesInOneDay * daysNormalized;
}

export function removeQuantityFromMaxAmount(
  articleLine: IShoppingCartMaxAmountArticleLine
): IShoppingCartMaxAmountArticleLine {
  if (articleLine.maxAmount) {
    const currentCalcAmount = normalizeDosageQuantityTo30Days(
      articleLine.dosage,
      articleLine.associatedQuantityPerUnit.quantity
    );
    articleLine.maxAmount.currentQuantity -= currentCalcAmount;
  }
  return articleLine;
}

export function setQuantityToMaxAmount(
  articleLine: IShoppingCartMaxAmountArticleLine
): IShoppingCartMaxAmountArticleLine {
  if (articleLine.maxAmount) {
    const currentCalcAmount = normalizeDosageQuantityTo30Days(
      articleLine.dosage,
      articleLine.associatedQuantityPerUnit.quantity
    );
    articleLine.maxAmount.currentQuantity += currentCalcAmount;
  }
  return articleLine;
}
